import { connect } from 'react-redux';
import {
  branch,
  compose,
  renderComponent,
  withPropsOnChange,
  withState,
} from 'recompose';

import Error from '../Error';
import { Logger } from '../../../../modules/infra/observability/logger';
import { getActiveShop, getCurrentUserId, getCurrentUserUsername } from '../../../auth/selectors';

export default compose(
  connect(
    state => ({
      shop: getActiveShop(state),
      userId: getCurrentUserId(state),
      username: getCurrentUserUsername(state),
    }),
  ),
  withState('isError', 'setIsError', false),
  withPropsOnChange(
    ['error', 'busy', 'timeout'],
    (props) => {
      if (props.error || props.busy || props.timeout) {
        Logger.log('Failed kiosk mode handoff', {
          event: 'Failed kiosk mode handoff',
          error: props.error,
          busy: props.busy,
          timeout: props.timeout,
          user: {
            id: props.userId,
            username: props.username,
          },
          shop: {
            id: props.shop.id,
            name: props.shop.name,
          },
        });

        props.setIsError(true);
        setTimeout(() => {
          props.setIsError(false);
        }, 5000);
      }
    },
  ),
  branch(
    ({ isError }) => isError,
    renderComponent(Error),
  ),
);
